import LocationSvg from "./room_card/LocationSvg";
import LocationGraySvg from "./room_card/LocationGraySvg";
import BedSvg from "./room_card/BedSvg";
import SquareSvg from "./room_card/SquareSvg";

export default function Room({data}) {

    const SliderPhotos = () => (
        <div 
            className="slider"
            style={{backgroundImage: `url(${data._dev_imgs[0]})`}}
        >
            <div className="pin">
                <LocationSvg/>
                {data.city}
            </div>
        </div>
    );

    const Content = ({data}) => (
        <div className="content">
            <h4 className="title">{data.name}</h4>
            <p className="location">
                <LocationGraySvg/>
                {data.city}, {data.street}</p>
            <p className="detail">
                <BedSvg/>
                {Number(data.capacity)}
            </p>
            <p className="detail">
                <SquareSvg/>
                {data.size || 0}m2
            </p>
        </div>
    );

    return data && (
        <a href={`/dynamic?id=${data.id}`} className="single-apartament">
            <SliderPhotos/>
            <Content data={data}/>
        </a>
    )
}